// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","703":"component---src-pages-socials-js"}[chunkId] + "-" + {"678":"69b295bbbe3b778dacf8","682":"365703cd2d4107bb3d6d","703":"16f0cabd944f6bea28a2"}[chunkId] + ".js";
};